var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.11834L6.55193 0.637294C6.74022 0.454235 7.0455 0.454235 7.23378 0.637294C7.42207 0.820352 7.42207 1.11715 7.23378 1.30021L4.34093 4.11271C4.15264 4.29576 3.84736 4.29576 3.65907 4.11271L0.766216 1.30021C0.577928 1.11715 0.577928 0.820352 0.766216 0.637294C0.954505 0.454235 1.25978 0.454235 1.44807 0.637294L4 3.11834Z",
    fill: "#022B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.776c5f4bf23019b4de50dd9074c0bf5c.svg";
export { ForwardRef as ReactComponent };